export default __webpack_public_path__ + "static/media/promo_1.0a7a71ba.jpg";